<template>
    <contract-component 
        title="Seleccione el plan que desee contratar"
        :disabled="false"
        btn_text="Contratar"
        :submit_func="submit"
        :submitting="submitting"
    ></contract-component>
</template>

<script>
    import ContractComponent from "../components/ContractComponent.vue";
    import { mapActions } from "vuex";
import { client } from '../api/client';

    export default {
        name: "CreateNewContract",
        components: {
            ContractComponent,
        },

        data() {
            return {
                submitting: false,
            };
        },
        methods: {
            async submit() {
                this.submitting = true;
                try {
                    await this.createContract();

                    var child_item = this.$children[0];
                    var selected_plan = child_item.contract_types.find(x => x.id == child_item.service_plan)

                    let payment_params = new URLSearchParams();
                    payment_params.append("amount", selected_plan.price * 100)

                    client.get('get_paycomet_uri', { params: payment_params }).then(response => {
                        let paycometURI = response['data']['uri']
                        // window.open(paycometURI, "_self")
                        window.open(paycometURI)
                    })

                } catch (error) {
                    console.error(error);
                } finally {
                    this.submitting = false;
                    this.$router.push({ name: "document-list" });
                }
            },
            ...mapActions({
                createContract: "contracts/createContract",
            }),
        },
    };
</script>
